
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults");
import { company } from '@components/config/company/Details';
import { DefaultSeo, NextSeo } from 'next-seo';
import { NEXT_SEO_DEFAULT } from '../next-seo.config';
import { JsonLdOrg } from '@components/config/strucureData/OrganisationJsonLd';
import { JsonLdFaq } from '@components/config/strucureData/FaqJsonLd';
import { JsonLdReview } from '@components/config/strucureData/ReviewsJsonLd';
import DriveWithUs from '@pages/driveWithUs';

export default function Index() {
  return (
    <>
      <NextSeo
        title={`Drive with Us| ${company.name}`}
        description="Enjoy flexible shifts and substantial earning potential when you drive with Shipley Central Taxis. Become a part of your local taxi driver's community."
        openGraph={{
          url: `${company.url}/drive-with-us`,
        }}
        canonical={`${company.url}/drive-with-us`}
      />
      <JsonLdOrg />
      <JsonLdFaq />
      <JsonLdReview />
      <div>
        <DriveWithUs />
      </div>
    </>
  );
}
